module.exports = __webpack_public_path__ + "static/img/更多@3x.43dd934.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/更多@3x.png
// module id = 778
// module chunks = 358